<template>
<div style="display:inline-block">
  <el-form-item :label="form.name" :prop="form.model"
                :class="[form.options.required?'label-blue':'']"
                :rules="form.rules"
                :required="form.options.required"
                v-show="!form.options.hidden"
                style="padding-left:10px;line-height:36px;"
  >
    <el-select  ref="selectRef"
                v-model="value[form.model]"
               :placeholder="form.options.placeholder"
               :disabled="inputDisable"
               @change="onInput"
               @focus="onFocus"
               :clearable="!form.options.clearable"
               :multiple="form.options.multiple"

               style="width:226px"
               :type="form.options.dataType"
               :filterable="form.options.remoteSearch"
               :allow-create="form.options.allowCreate"
               :remote="typeof form.options.remoteSearchFunc === 'function'"
               :remote-method="remoteMethod"
               :loading="loading"
               value="">
      <el-option
        v-for="item in optionData"
        :key="item[form['options']['props']['value']]"
        :label="item[form['options']['props']['label']]"
        :value="item[form['options']['props']['value']]">
      </el-option>
    </el-select>
  </el-form-item>
  <el-dialog v-if="this.form.dataSource=='route'" :visible.sync="dialogTableVisible" :show-close="false" class="select_dialog" width="60%" style="min-width:970px;z-index:3666;" custom-class="dialogStyle">
        <el-row>
          <el-col :span="18">
            <el-form style="display: inline-block;width:40%;">
              <el-form-item :label="selectName" class="input_margin0">
                <el-input v-model="selectCode" style="width:200px;" size="mini" placeholder="请输入内容" clearable></el-input>
              </el-form-item>
            </el-form>
            <el-button type="primary" size="mini" @click="getRouteData">查询</el-button>
          </el-col>
          <el-col :span="6">
            <div class="text-align_right">
              <div style="margin-right:40px">
                <el-button type="primary" size="mini" @click="selectAdd">确认</el-button>
                <el-button type="" size="mini" @click="dialogTableVisible=false">返回</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-tabs type="border-card">
          <el-tab-pane label="路线信息">
            <el-table ref="routeTable" height="380px" size="small" :default-sort = "{prop: 'routeLocation', order: 'descending'}" :data="routeTable" tooltip-effect="dark" @row-click="handleRowClick" style="width: 100%" @selection-change="handleSelectionChange" border>
              <el-table-column label="" width="40">
                <template slot-scope="scope">
                  <div style="position: relative;">
                    <el-checkbox v-if="scope.row.r5 === null || scope.row.r5 === ''" v-model="boolType._false"></el-checkbox>
                    <el-checkbox v-else v-model="boolType._true"></el-checkbox>
                    <div style="position: absolute;top: 0;left: -5px;width: 25px;height: 25px;z-index: 100;"></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="路线编码" prop="routeCode">
              </el-table-column>
              <el-table-column label="公路等级" sortable prop="highwayLevelCode">
              </el-table-column>
              <el-table-column label="起点桩号(km)" sortable prop="startStake">
                <template slot-scope="scope">{{ scope.row.startStake | stakeTableFilter }}</template>
              </el-table-column>
              <el-table-column label="止点桩号(km)" sortable prop="endStake">
                <template slot-scope="scope">{{ scope.row.endStake | stakeTableFilter }}</template>
              </el-table-column>
              <el-table-column label="主线里程" prop="routeLen">
              </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next,total,sizes " :current-page="routePageIndex"
              :page-sizes="[10, 20, 50, 100]" @size-change="sizeChange" @current-change="goCurrentChange" :total="routePageCount">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="已选路线">
            <el-table ref="multipleSelection" height="380px" v-loading="multipleSelectionLoading" size="small" :default-sort = "{prop: 'routeLocation', order: 'descending'}" :data="multipleSelection" tooltip-effect="dark" style="width: 100%" border>
              <el-table-column
                width="50">
                <template slot-scope="scope">
                  <el-button @click="delSelect(scope.row,scope.$index)" size="mini" type="danger" icon="el-icon-delete" circle></el-button>
                </template>
              </el-table-column>
              <el-table-column label="路线编码" prop="routeCode">
              </el-table-column>
              <el-table-column label="公路等级" sortable prop="highwayLevelCode">
              </el-table-column>
              <el-table-column label="起点桩号(km)" sortable prop="startStake">
                <template slot-scope="scope">{{ scope.row.startStake | stakeTableFilter }}</template>
              </el-table-column>
              <el-table-column label="止点桩号(km)" sortable prop="endStake">
                <template slot-scope="scope">{{ scope.row.endStake | stakeTableFilter }}</template>
              </el-table-column>
              <el-table-column label="主线里程" prop="routeLen">
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
</div>
</template>

<script>
export default {
  name: 'DynamicSelect',
  // components: {},
  data () {
    return {
      /**路线select*/
      multipleSelectionLoading: false,
      //
      selectCode:'',//查询条件
      selectName:'查询名称',
      multipleSelection:[],
      dialogTableVisible: false, //选择
      routeTable:[],
      routePageIndex:1,
      routePageSize:10,
      routePageCount:0,

      loading: false,
      key: '',
      mainValue: '',
      formData: { value: '' },
      optionData: [],
      remoteSearchFunc: () => {
      },
      boolType: {
        _false: false,
        _true: true,
      },
    }
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          name: '',
          prop: '',
          icon: '',
          className: '',
          options: {
            width: '100%',
            defaultValue: '',
            required: false,
            multiple:false,
            dataType: 'string',
            clearable:false,
            pattern: '',
            placeholder: '',
            customClass: '',
            disabled: false,
            options: [{}],
            remote: false,
            props: {
              value: 'value',
              label: 'label'
            },
            remoteFunc: () => {
            },
            remoteSearch: false,
            allowCreate:false,
            remoteSearchFunc: () => {
            },
            blurs:false,
          },
          key: '',
          dataSource:'',
          model: 'value',
          modelLabel:'',
          rules: [{}]
        }
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.mainValue = val
      }
    },
    form: {
      deep: true,
      handler (nv){
        this.optionData = nv['options']['options']
      }
    },
    "form.options.required": function(newVal){//更改options设置时，下拉数据被清空。为此设置的属性
      let that = this
      if (that.form['options']['remote']) {
        if (that.form['options'].hasOwnProperty('remoteFunc')) {
          if (typeof that.form['options']['remoteFunc'] === 'function') {
            that.form['options']['remoteFunc'](that, that.forms)
          }
        }
      }
    },
  },
  methods: {
    onInput (val) {
      (val==null||val.length==0)&&(this.value[this.form.modelLabel]='');
      let that = this
      that.$emit('input', that.value, that.form.model)
      if (typeof that.form.options.changeFunc === 'function') { // 判断是否存在数据改变事件
        that.form.options.changeFunc(that.value[that.form.model], that, that.forms)
      }
    },
    setValue (val) {
      this.mainValue = val
    },
    setList (arr) {
      this.optionData = arr
    },
    remoteMethod (query) {
      let that = this
      if (typeof that.form.options.remoteSearchFunc === 'function') {
        that.form.options.remoteSearchFunc(query, that, that.forms)
      }
    },
    onFocus () {
      this.getRouteData();
      let that = this
      if (typeof that.form.options.onFocus === 'function') { // 判断是否存在数据改变事件
        that.form.options.onFocus();
      }
      if(that.form.options.blurs){
        that.$refs.selectRef.blur();
      }
    },
    /*************************路线select_Func************************************/
    forSetR5(){
      for (let index = 0; index < this.multipleSelection.length; index++) {
        const element = this.multipleSelection[index];
        element.r5 = index;
      }
      this.routeTable = this.setSelectR5(this.routeTable);
    },
    setSelectR5(list){
        let data = list || [];
        data.forEach(element => {
            let index = null;
            for (let num = 0; num < this.multipleSelection.length; num++) {
                element.routeId === this.multipleSelection[num].routeId && ( index = num );
            }
            element.r5 = index
        });
        return data
    },
    getRouteData(){
      if(this.form.dataSource!=''){
        this.dialogTableVisible=true;
        switch (this.form.dataSource) {
          case "route":
            this.selectName='路线编码'
            this.$http.postX(this.$url.route.search,{
              routeCode:this.selectCode,
              isFull:'',
              pageIndex:this.routePageIndex,
              pageSize:this.routePageSize,
            }).then(res=>{
              this.routeTable=this.setSelectR5(res.data);
              this.routePageCount=res.pageCount;
            })
            break;
          default:
            break;
        }
      }
    },
    sizeChange(val){
      this.routePageSize=val;
      this.getRouteData();
    },
    goCurrentChange(val) {
      this.routePageIndex = val;
      this.getRouteData();
    },
    handleSelectionChange(val){
      // this.multipleSelection = val;
    },
    handleRowClick(row, column, event) {
      this.multipleSelectionLoading = true;
      this.$refs.routeTable.toggleRowSelection(row)
      if(row.r5 === null || row.r5 === ''){
        row.r5 = this.multipleSelection.length;
        let form = JSON.parse(JSON.stringify(row));
        this.multipleSelection.splice(this.multipleSelection.length, 0, form);
      }else{
        let index = row.r5;
        this.multipleSelection.splice(index, 1);
        row.r5 = "";
        this.forSetR5()
      }
      console.log(this.multipleSelection)
      this.multipleSelectionLoading = false;
    },
    selectAdd(){//路线选择确认
      if (this.multipleSelection === undefined || this.multipleSelection.length === 0) {
          this.$message({
              message: '请先勾选路线信息进行操作!',
              type: 'warning',
              offset: 300
          });
      } else {
        let codeList=[];
        let idList=[];
        let lists=this.multipleSelection;
        lists.forEach(element => {
          idList.push(element.routeId);
          codeList.push(element.routeCode);
        });
        this.value[this.form.model]=codeList;
        this.value[this.form.modelLabel]=idList.join(',');
        this.dialogTableVisible=false;
      }
    },
    delSelect(row){
      this.multipleSelectionLoading = true;
      let index = row.r5;
      this.routeTable.forEach(element => {
        if(row.routeId === element.routeId){
          element.r5 = "";
        }
      });
      this.multipleSelection.splice(index,1);
      this.forSetR5()
      this.multipleSelectionLoading = false;
      // this.$refs.routeTable.toggleRowSelection(row);
    },
  },
  created () {
    let that = this
    that.key = that.form.key
    if (that.form.hasOwnProperty('options')) {
      that.value[that.form.model] = that.value[that.form.model] || that.form['options']['defaultValue'] || ''
    }
    // 下拉框数据
    if (that.form.hasOwnProperty('options')) {
      if (that.form.options.hasOwnProperty('remoteSearch')) { //远程搜索方法
        that.remoteSearchFunc = that.form['options']['remoteSearchFunc']
      }
      if (!that.form['options']['remote']) {
        if (that.form['options'].hasOwnProperty('options')) {
          let listData=that.form['options']['options'];
          if((listData.length>0)&&(listData[0].value)&&(typeof(listData[0].value)=="string")&&(listData[0].value.indexOf("Option")>=0)){
            listData=[]
          }
          that.optionData = listData
        }
      } else {
        if (that.form['options'].hasOwnProperty('remoteFunc')) {
          if (typeof that.form['options']['remoteFunc'] === 'function') {
            that.form['options']['remoteFunc'](that, that.forms)
          }
        }
      }
    }
  },
  mounted () {
    let that = this
    that.$emit('init', that.key, that)
  },
  computed: {
    inputDisable () {
      return this.disabled || this.form.options.disabled
    }
  }
}
</script>

<style scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Form/DynamicSelect.vue"
}
</vue-filename-injector>
